module.exports = __webpack_public_path__ + "img/F_image2.9ad4ca65.jpg";